import { Component } from '@angular/core';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { PopupSelectDiscount } from '../popup-select-discount/popup-select-discount';
import { TPVServices } from '../../../tpv/services';
import { TakeawayServices } from '../../../takeaway/services';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PrintServices } from '../../../services/printServices';
import { NotificationsServices } from '../../../services/notificationsServices';
import { TpvTicketSelectedPayIndvPage } from '../../../tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-pay-indv/tpv-ticket-selected-pay-indv';
import { ConfigurationPaymentMethodsPage } from '../../../configuration/configuration-payment-methods/configuration-payment-methods';
import { TpvTicketSelectedPayPage } from '../../../tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-pay/tpv-ticket-selected-pay';
import { TakeawayOrderPayPage } from '../../../takeaway/takeaway-order-pay/takeaway-order-pay';


/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup-select-payment',
  templateUrl: 'popup-select-payment.html',
})
export class PopupSelectPayment {
  table: any;
  origin: any;
  qr_link: string = '';
  qr_link_done: boolean = false;
  payplazaMctPayChargeUid: string = '';
  mctPayChargeUid: string = '';
  tk_ticket_medio = 0;
  mct_payments_active = false;
  can_send_email = false;
  sunmi_device_name: string = "";
  public firestore: any;


  constructor(
    public globals: Globals,
    public translate: TranslateService,
    public viewCtrl: ViewController,
    private modalCtrl: ModalController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public takeawayServices: TakeawayServices,
    public http: HttpClient,
    private printServices: PrintServices,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    private notificationsServices: NotificationsServices) {
    this.table = this.navParams.get('table');
    this.origin = this.navParams.get('origin');

    if (this.origin == 'tpv' || this.origin == 'orders') {
      if (this.table.persons != "") {
        this.tk_ticket_medio = this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index) / this.table.persons;
      } else {
        this.tk_ticket_medio = this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index);
      }

      if (this.table.customer.UID) {
        this.can_send_email = true;
      }

    } else {
      if (this.table.persons != "") {
        this.tk_ticket_medio = this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index) / this.table.persons;
      } else {
        this.tk_ticket_medio = this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index);
      }

      if (this.table.customer_uid) {
        this.can_send_email = true;
      }
    }
  }

  ionViewWillEnter() {
    //recuperamos modelo
    if (this.globals.restaurant.printer_type == 'sunmi') {
      var index = this.globals.sunmi_printers.findIndex(x => x.name == this.globals.device_model);
      if (index >= 0) {
        this.sunmi_device_name = this.globals.sunmi_printers[index].name;
      }
    }
    //Variable para comprobar si hay algun metodo de mctPay activo
    this.mct_payments_active = this.globals.checkPaymentsMctPayActive();
  }

  close(payment) {
    this.viewCtrl.dismiss(payment);
  }

  openDiscounts() {
    this.viewCtrl.dismiss();
    let profileModal = this.modalCtrl.create(PopupSelectDiscount, {
      type: this.table.type,
    });
    profileModal.onDidDismiss(data => {
    });
    profileModal.present();
  }

  loadingPopup;
  async createMctPayCharge() {
    this.loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-generando-qr')
    });
    this.loadingPopup.present();
    //Recuperamos la url del mct_pay_web, para el qr
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('table_uid', this.table.UID);

    this.http.post(this.globals.analytics_path + 'mctwebpay/create_mct_pay_charge', params, {})
      .subscribe(async res => {
        this.mctPayChargeUid = res['mct_pay_charge_uid'];
        this.getMctPAyChargeQr();
      });
  }

  pay(type) {
    if (type == 'cash') {
      if (this.origin == 'tk') {
        this.navCtrl.push(TakeawayOrderPayPage);
      } else {
        this.navCtrl.push(TpvTicketSelectedPayPage, {
          callback: this.myCallbackFunction,
          _viewCtrl: this.viewCtrl
        });
      }
    } else {
      if (this.origin == 'tk') {
        this.payTk(type);
      } else {
        this.payTpvOrder(type);
      }
    }
  }

  myCallbackFunction = function (_params, _viewCtrl) {
    return new Promise<void>((resolve, reject) => {
      _viewCtrl.dismiss(true);
      resolve();
    });
  }

  //
  payIndv() {
    //this.viewCtrl.dismiss();
    this.navCtrl.push(TpvTicketSelectedPayIndvPage);
  }

  //
  async payTk(type) {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cobrando')
    });
    loadingPopup.present();
    await this.takeawayServices.cashTicketPay(type, this.takeawayServices.selected_type);
    //opencashdrawer if can
    if (type == 'cash') {
      this.printServices.openCashDrawerByType();
    }
    this.tpvServices.keyboard_screen = '';
    loadingPopup.dismiss();
    this.globals.side_menu_active = 'tpv';
    this.close(true);
  }

  //
  async payTpvOrder(type) {
    //limita a no cobrar mas de una vez y cree errores 
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cobrando')
    });
    loadingPopup.present();
    await this.tpvServices.cashTicketPay(type, this.tpvServices.selected_type);
    //opencashdrawer if can
    if (type == 'cash') {
      this.printServices.openCashDrawerByType();
    }
    //interval cancel ticket per neteja ok
    var interval = setInterval(() => {
      this.tpvServices.cancelTicket('clean');
      clearInterval(interval);
    }, 1000);
    this.tpvServices.keyboard_screen = '';
    loadingPopup.dismiss();
    //si lo a vendido un un waiter por comandero 
    if (this.tpvServices.is_in_order) {
      //creamos y enviamos una notificacio a tots els usuaris
      let _notification = {
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'title': this.translate.instant("notification-push-pedido-vendido-comandero-title"),
        'description': this.translate.instant("notification-push-pedido-vendido-comandero-desc-1") + this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].name + this.translate.instant("notification-push-pedido-vendido-comandero-desc-2"),
      }
      this.notificationsServices.notificationPushAllRestaurant(_notification);
    }
    if (this.origin == 'tpv') {
      this.globals.side_menu_active = 'tpv';
      this.close(true);
    } else {
      this.globals.side_menu_active = 'order';
      this.close(true);
    }
  }

  //
  async payplaza() {
    var total = await this.total_ticket_selected();
    var amount_payplaza = Math.round(total * 100);
    try {
      let actionName = 'com.payplaza.dev.action.TRANSACTION';

      let extras = [
        { "name": "com.payplaza.extra.TRANSACTION_FLOW", "value": "payment", "dataType": "String" },
        { "name": "com.payplaza.extra.TRANSACTION_TYPE", "value": "purchase", "dataType": "String" },
        { "name": "com.payplaza.extra.CURRENCY_CODE", "value": "EUR", "dataType": "String" },
        { "name": "com.payplaza.extra.AMOUNT", "value": amount_payplaza, "dataType": "Long" },
        { "name": "com.payplaza.extra.ORDERREF", "value": "TRA-" + this.table.UID.substr(0, 10), "dataType": "String" },
        { "name": "com.payplaza.extra.TIPPING", "value": false, "dataType": "Boolean" }
      ];

      window["plugins"].launcher.launch({ actionName: actionName, extras: extras },
        json => {
          if (json.isActivityDone) {
            if (json.extras) {
              if (json.extras['com.payplaza.extra.TRANSACTION_RESULT'] === 'SUCCESS') {
                //caso pago correcto crear mct_pay_charge y obj de cf (crea ticket,etc)
                //this.createMctPayChargeAndCF(json.extras, 'payplaza');
                this.pay('payplaza');
              } else { }
            }
          }
        },
        errMsg => { });

    } catch (error) { }
  }

  async verifone() {
    var total = await this.total_ticket_selected();
    var amount_verifone = Math.round(total * 100);

    try {
      let actionName = 'com.mycheftool.mctpay.action.TRANSACTION';

      let extras = [
        { "name": "AMOUNT", "value": amount_verifone, "dataType": "String" },
      ];

      window["plugins"].launcher.launch({ actionName: actionName, extras: extras },
        json => {
          if (json.isActivityDone) {
            if (json.extras) {
              if (json.extras['PAYMENT_RESULT'] === 'COMPLETED') {
                //caso pago correcto crear mct_pay_charge y obj de cf (crea ticket,etc)
                //this.createMctPayChargeAndCF(json.extras, 'verifone');
                this.pay('verifone');
              } else { }
            }
          }
        },
        errMsg => { });

    } catch (error) { }
  }


  async createMctPayChargeAndCF(payment_object, payment_type) {
    //Recuperamos el mct pay charge uid
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('table_uid', this.table.UID);
    const response = await this.http.post(this.globals.analytics_path + 'mctwebpay/create_mct_pay_charge', params, {}).toPromise();
    this.payplazaMctPayChargeUid = response['mct_pay_charge_uid'];

    //creamos el obj que cf usara para crear ticket y limpiar
    const params_cf = new HttpParams()
      .set('payment_type', payment_type)
      .set('payment_object', JSON.stringify(payment_object))
      .set('table_uid', this.table.UID)
      .set('mct_pay_charge_uid', this.payplazaMctPayChargeUid);
    await this.http.post(this.globals.analytics_path + 'mctwebpay/create_task_2_cf', params_cf, {}).toPromise();
  }


  async total_ticket_selected() {
    var total = 0;
    for (let key in this.table.ticket.list) {
      let value = this.table.ticket.list[key];
      //value.state_indv es para que no sume los elementos pagados individuales
      if (value.count && !value.delete) {
        total += parseFloat(value.price); //Sumamos el precio del plato
        //Variations
        if (value.variation) {
          for (let key2 in value.variation) {
            let variation = value.variation[key2];
            total += parseFloat(variation.price);
          }
        }
      }
    }

    if (this.table.ticket.tip) {
      //total += this.globals.createTotal(Number(this.table.ticket.tip), Number(this.globals.user_tax));
      total += this.table.ticket.tip;
    }
    return total;
  }

  getMctPAyChargeQr() {
    this.http.post(this.globals.api_path + 'mctwebpay/generate_charge_qr', {
      mct_pay_charge: this.mctPayChargeUid
    }, {})
      .subscribe(async res => {
        this.qr_link = res['url_qr'];
        this.qr_link_done = true;
        this.loadingPopup.dismiss();
      });
  }

  openConfig() {
    this.globals.side_menu_config_active = 'payment_methods';
    this.globals.side_menu_active = '';
    this.navCtrl.push(ConfigurationPaymentMethodsPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-select-payment/popup-select-payment.ts